import styles from "./Library.module.css";
import contentStyles from "shared/ContentList/ContentList.module.css";

import { QueryTableRow } from "gui/BrowseQueriesPage/List/QueriesList";
import { DashboardTableRow } from "gui/BrowseDashboardsPage/List/DashboardsList";

import { useRecentlyUpdated } from "./hooks/useRecentlyUpdated";
import { toQueryElementType } from "./shared/Query/queryElement";
import { toDashboardElementType } from "./shared/Dashboard/dashboardElement";
import useQueriesFavorites from "gui/BrowseQueriesPage/api/useQueriesFavorites";
import useDashboardsFavorites from "gui/BrowseDashboardsPage/api/useDashboardsFavorites";
import type { SessionWithUser } from "lib/users/types";

export function UpdatedRecently({ session }: { session: SessionWithUser }) {
  const recentlyUpdated = useRecentlyUpdated(session);
  const contentResults = recentlyUpdated.data?.get_content.results;
  const queries =
    contentResults?.filter((element) => element.type === "query") ?? [];
  const queriesFavorites = useQueriesFavorites(queries.map((q) => q.id));

  const dashboards =
    contentResults?.filter((element) => element.type === "dashboard") ?? [];
  const dashboardsFavorites = useDashboardsFavorites(
    dashboards.map((d) => d.id)
  );

  if (!contentResults || contentResults?.length === 0) {
    return null;
  }

  return (
    <div className={styles.lastUpdated}>
      <h2>Updated recently</h2>
      <table className={contentStyles.table}>
        <tbody>
          {contentResults.map((element) => {
            if (element.type === "query" && element.query) {
              return (
                <QueryTableRow
                  key={element.query.id}
                  query={toQueryElementType(element.query)}
                  favorites={queriesFavorites}
                  origin={"creations"}
                />
              );
            }

            if (element.type === "dashboard" && element.dashboard) {
              return (
                <DashboardTableRow
                  key={element.dashboard.id}
                  dashboard={toDashboardElementType(element.dashboard)}
                  favorites={dashboardsFavorites}
                  origin={"creations"}
                />
              );
            }
          })}
        </tbody>
      </table>
    </div>
  );
}
